import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";

interface IAddBillAutomaticAddSuggestionModalProps extends IUseModalProps {
  onSelect: (automatic: boolean) => void;
}

export const AddBillAutomaticAddSuggestionModal: React.FC<
  IAddBillAutomaticAddSuggestionModalProps
> = (props) => {
  const { onSelect, ...rest } = props;
  const { t } = useTranslation();

  const modal = useModal(rest);

  const handleSelect = (automatic: boolean) => {
    onSelect(automatic);
    modal.close();
  };

  return (
    <Modal
      modal={modal}
      title={t("addBillAutomaticAddSuggestionModal.title")}
      subtitle={t("addBillAutomaticAddSuggestionModal.subtitle")}
      className="md:max-w-2xl"
      actionButtons={
        <React.Fragment>
          <Button
            variant="secondary"
            onClick={() => handleSelect(false)}
            className="w-full"
          >
            {t("addBillAutomaticAddSuggestionModal.buttons.manual")}
          </Button>
          <Button className="w-full" onClick={() => handleSelect(true)}>
            {t("addBillAutomaticAddSuggestionModal.buttons.automatic")}
          </Button>
        </React.Fragment>
      }
    ></Modal>
  );
};
